<div class="modal-header" style="border: none;">
    <h4 class="modal-title title" id="modal-basic-title">Pide tu préstamo en sólo unos minutos</h4>

</div>


<form [formGroup]="leadForm" (ngSubmit)="sendLead()" novalidate="novalidate" class="pb-3">
    <div class="modal-body">

        <div class="form-group">
            <input type="email" class="form-control" id="inputEmail" placeholder=" " formControlName="email"
                [class.is-invalid]="emailRequiredValidation || emailPatternValidation"
                [class.is-valid]="validField('email')">
            <label class="form-control-placeholder" for="inputEmail">Ingresa tu correo electrónico</label>

            <!-- INPUT ERROR MESSAGES -->
            <div *ngIf="emailRequiredValidation" [class.invalid-feedback]="emailRequiredValidation">
                Ingrese correo electrónico
            </div>

            <div *ngIf="emailPatternValidation" [class.invalid-feedback]="emailPatternValidation">
                Ingrese un correo electrónico válido
            </div>


            <div *ngIf="!emailValid" style="color: #dc3545; font-size: 80%; margin-top: .25rem; padding-bottom: 10px;">
                El correo ingresado no es válido, intente con otro correo.
            </div>

            <!-- INPUT ERROR MESSAGES -->

        </div>


        <div class="form-group">
            <input class="form-control" id="inputMobileNumber" placeholder=" " formControlName="mobile_number"
                (keypress)="isNumber($event)" type="text"
                [class.is-invalid]="mobileNumberRequiredValidation || mobileNumberMinLengthValidation || mobileNumberMaxLengthValidation"
                [class.is-valid]="validField('mobile_number')">
            <label class="form-control-placeholder" for="inputEmail">Ingresa tu teléfono móvil a 10 dígitos</label>

            <!-- INPUT ERROR MESSAGES -->
            <div *ngIf="mobileNumberRequiredValidation" [class.invalid-feedback]="mobileNumberRequiredValidation">
                Ingrese teléfono móvil
            </div>
            <div *ngIf="mobileNumberMinLengthValidation" [class.invalid-feedback]="mobileNumberMinLengthValidation">
                El teléfono móvil debe tener 10 dígitos
            </div>
            <div *ngIf="mobileNumberMaxLengthValidation" [class.invalid-feedback]="mobileNumberMaxLengthValidation">
                El teléfono móvil debe máximo 10 dígitos
            </div>
            <div *ngIf="mobileNumberPatternValidation" [class.invalid-feedback]="mobileNumberPatternValidation">
                Ingrese teléfono móvil válido
            </div>
            <!-- INPUT ERROR MESSAGES -->
        </div>



        <small class="terms">Al registrarte aceptas los <a [routerLink]="[ '/terminos-y-condiciones' ]"
                style="color: black; font-style: italic;" target="_blank" queryParamsHandling="preserve">términos y
                condiciones</a> y el <a [routerLink]="[ '/aviso-de-privacidad']" target="_blank"
                queryParamsHandling="preserve" style="color: black; font-style: italic;">aviso de
                privacidad</a> del sitio web. </small>


    </div>




    <div class="modal-footer" style="border: none;">
        <button [disabled]="processing" type="submit" class="btn btn-primary btn-block splashButton">
            <span *ngIf="!processing">Solicitar</span>
            <span *ngIf="processing">
                {{ textButton }}
                <i class="fa fa-spinner fa-spin spinner-big " aria-hidden="true"></i>
            </span>
        </button>
    </div>


</form>

<app-toastr></app-toastr>